import { labelIdOf } from '../fieldIds';

export const FieldLabel = ({
  id,
  labelsControl,
  text,
  className,
  hidden,
}: {
  id: string;
  labelsControl: boolean;
  text: string;
  className: string;
  hidden?: boolean;
}) => {
  // Hidden visually, but still the input's accessible name via htmlFor / aria-labelledby
  const resolvedClassName = hidden ? 'sr-only' : className;
  return labelsControl ? (
    <label id={labelIdOf(id)} htmlFor={id} className={resolvedClassName}>
      {text}
    </label>
  ) : (
    <span id={labelIdOf(id)} className={resolvedClassName}>
      {text}
    </span>
  );
};
